<div class="form-row row" style="margin-top: -45px;" *ngIf="!show_search_option">
  <div class="col-sm-12 col-lg-3 col-md-3" style="margin-left: 1%;">
    <label style="font-size: 15px;">Enter Agent Code and Search <i class="material-icons"
        style="color: red;font-size: 14px;">star</i></label>
    <input type="number" class="form-control" (keydown.enter)="checkAgentExists()" id="booth_number"
      [(ngModel)]="entered_agent_code"
      style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; height: 40%; font-size: 20px;">
  </div>
  <div class="col-sm-6 col-lg-2 col-md-2" style="margin-left: 12px; margin-top: 4%;">
    <button mat-raised-button color="primary" (click)="checkAgentExists()" class="button-class"
      style="font-size: 20px; height: 40px;    margin-top: -20px;"
      [disabled]="entered_agent_code == null">Search</button>
  </div>
</div>
<div class="card" *ngIf="show_register_form" style="padding: 25px;margin-top: 45px;">
  <div class="mat-card-header" style="font-size: medium;  font-weight: 500; color: #278ecd;">
    Agent Register
    <span class="material-icons" style="float: right;" (click)="showFullAgentForm()"
      *ngIf="display_agent_form">keyboard_arrow_up</span>
    <span class="material-icons" style="float: right;" (click)="showFullAgentForm()"
      *ngIf="!display_agent_form">keyboard_arrow_down</span>
  </div>
  <form [formGroup]="agent_register_form" *ngIf="display_agent_form" style="margin-top: 20px;">
    <div class="row">
      <div class="col">
        <!-- agent code -->
        <div class="form-group">
          <label>Agent code <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <!-- <span *ngIf="!agent_register_mode"> -->
            <!-- <span *ngIf="agent_edit_control['agent_code']" (click)="allowPermission('agent_code')" style="font-size: 10px;color: lightslategrey;border: 1px solid grey;border-radius: 5px;
              padding: 4px;margin-left: 15px; background: ghostwhite; text-transform: uppercase;cursor: pointer;">
                Edit <span class="material-icons" style="font-size: 10px;">
                  create
                </span>
              </span>
              <span *ngIf="!agent_edit_control['agent_code']"
                (click)="updateAgentField('agent_code', agent_register_form.value.agent_code, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span> -->
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['agent_code']) && !agent_register_mode? 'disabled' : null"
            formControlName='agent_code'>
        </div>
      </div>
      <!-- first name -->
      <div class="col">
        <div class="form-group">
          <label>First Name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['first_name']" (click)="allowPermission('first_name')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['first_name']"
                (click)="updateAgentField('first_name', agent_register_form.value.first_name, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['first_name'])  && !agent_register_mode? 'disabled' : null"
            formControlName='first_name'>
        </div>
      </div>

      <!-- last name -->
      <div class="col">
        <div class="form-group">
          <label>Last Name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['last_name']" (click)="allowPermission('last_name')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">
                  create
                </span>
              </span>
              <span *ngIf="!agent_edit_control['last_name']"
                (click)="updateAgentField('last_name', agent_register_form.value.last_name, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['last_name']) && !agent_register_mode? 'disabled' : null"
            formControlName='last_name'>
        </div>
      </div>
      <!-- gender -->
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Gender <i class="material-icons"
              style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['gender_id']" (click)="allowPermission('gender_id')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['gender_id']"
                (click)="updateAgentField('gender_id', agent_register_form.value.gender_id, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <select class="form-control dropdown_box"
            [attr.disabled]="access(agent_edit_control['gender_id']) && !agent_register_mode? 'disabled' : null"
            formControlName='gender_id'>
            <option *ngFor="let gender of genders" [value]="gender['id']"
              [style.color]="agent_edit_control['last_name'] ? '#0000006b':'black'">{{gender['name']}} </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- union -->
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Union <i class="material-icons"
              style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['union_id']" (click)="allowPermission('union_id')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['union_id']"
                (click)="updateAgentField('union_id', agent_register_form.value.union_id, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <select class="form-control dropdown_box"
            [attr.disabled]="access(agent_edit_control['union_id']) && !agent_register_mode? 'disabled' : null"
            formControlName='union_id'>
            <option *ngFor="let union of unions" [value]="union['id']">{{union['name']}}
            </option>
          </select>
        </div>
      </div>
      <!-- street -->
      <div class="col">
        <div class="form-group">
          <label>Street
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['street']" (click)="allowPermission('street')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['street']"
                (click)="updateAgentField('street', agent_register_form.value.street, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['street']) && !agent_register_mode? 'disabled' : null"
            formControlName='street'>
        </div>
      </div>
      <!-- pincode -->
      <div class="col">
        <div class="form-group">
          <label>Pincode
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['pincode']" (click)="allowPermission('pincode')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['pincode']"
                (click)="updateAgentField('pincode', agent_register_form.value.pincode, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="number" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['pincode']) && !agent_register_mode? 'disabled' : null"
            formControlName='pincode' [maxlength]="6">
        </div>
        <div style="font-style: italic; font-size: small; color:red"
          *ngIf="agent_register_form.controls.pincode.errors !== null">
          {{ agent_register_form.controls.pincode.errors['error']}}
        </div>
      </div>
    </div>
    <div class="row">
      <!-- state -->
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">State <i class="material-icons"
              style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['state_id']" (click)="allowPermission('state_id')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['state_id']"
                (click)="updateAgentField('state_id', agent_register_form.value.state_id, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <select class="form-control dropdown_box" id="exampleFormControlSelect1"
            [attr.disabled]="access(agent_edit_control['agent_state_id']) && !agent_register_mode? 'disabled' : null"
            formControlName='state_id'>
            <option *ngFor="let state of states" [value]="state['id']">{{state['name']}} </option>
          </select>
        </div>
      </div>
      <!-- district -->
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">District <i class="material-icons"
              style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['district_id']" (click)="allowPermission('district_id')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['district_id']"
                (click)="updateAgentField('district_id', agent_register_form.value.district_id, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <select class="form-control dropdown_box"
            [attr.disabled]="access(agent_edit_control['district_id']) && !agent_register_mode? 'disabled' : null"
            formControlName='district_id'>
            <option *ngFor="let district of districts[agent_register_form.value.state_id]" [value]="district['id']">
              {{district['name']}} </option>
          </select>
        </div>
      </div>
      <!-- taluk -->
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Taluk <i class="material-icons"
              style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['taluk_id']" (click)="allowPermission('taluk_id')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['taluk_id']"
                (click)="updateAgentField('taluk_id', agent_register_form.value.taluk_id, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <select class="form-control dropdown_box"
            [attr.disabled]="access(agent_edit_control['taluk_id']) && !agent_register_mode? 'disabled' : null"
            formControlName='taluk_id'>
            <option *ngFor="let taluk of taluks[agent_register_form.value.district_id]" [value]="taluk['id']">
              {{taluk['name']}} </option>
          </select>
        </div>
      </div>
    </div>
    <!-- communication address -->
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Address
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['communication_address']"
                (click)="allowPermission('communication_address')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['communication_address']"
                (click)="updateAgentField('communication_address', agent_register_form.value.communication_address, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <textarea class="form-control code_box" rows="2"
            [attr.disabled]="access(agent_edit_control['communication_address']) && !agent_register_mode? 'disabled' : null"
            formControlName='communication_address'></textarea>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Mobile

            <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['mobile']" (click)="allowPermission('mobile')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['mobile']"
                (click)="updateAgentField('mobile', agent_register_form.value.mobile, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="number" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['mobile']) && !agent_register_mode? 'disabled' : null"
            formControlName='mobile'>
        </div>
        <div style="font-style: italic; font-size: small"
          [ngStyle]="{'color': agent_register_form.controls.mobile.valid? 'green': 'red'}"
          *ngIf="agent_register_form.controls.mobile.errors !== null">
          {{ agent_register_form.controls.mobile.errors['error']}}
        </div>
      </div>
      <!-- Alternate Mobile -->
      <div class="col">
        <div class="form-group">
          <label>Alternate Mobile
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['alternate_mobile']" (click)="allowPermission('alternate_mobile')"
                class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['alternate_mobile']"
                (click)="updateAgentField('alternate_mobile', agent_register_form.value.alternate_mobile, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="number" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['alternate_mobile']) && !agent_register_mode? 'disabled' : null"
            formControlName='alternate_mobile'>
          <div style="font-style: italic; font-size: small; color:red"
            *ngIf="agent_register_form.controls.alternate_mobile.errors !== null">
            {{ agent_register_form.controls.alternate_mobile.errors['error']}}
          </div>
        </div>
      </div>
      <!-- image -->
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlFile1">Agent Image <i class="material-icons"
              style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['image']" (click)="allowPermission('image')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['image']"
                (click)="updateAgentField('agent_image', agent_register_form.value.alternate_mobile, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="file" class="form-control-file" id="exampleFormControlFile1" (change)="toBase64($event)"
            [attr.disabled]="access(agent_edit_control['image']) && !agent_register_mode? 'disabled' : null"
            accept="image/*" value='image'>
        </div>
      </div>
      <div class="col" *ngIf="image != null">
        <img [src]="image" style="height: 100px;">
      </div>
    </div>
    <div class="row">

    </div>
    <div class="mat-card-header" style="font-size: medium;  font-weight: 500;  margin-bottom: 13px;  color: #278ecd;">
      Agent Proof
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Pan Number
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['pan_number']" (click)="allowPermission('pan_number')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['pan_number']"
                (click)="updateAgentField('pan_number', agent_register_form.value.pan_number, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['pan_number']) && !agent_register_mode? 'disabled' : null"
            formControlName='pan_number'>
          <div style="font-style: italic; font-size: small; color:red"
            *ngIf="agent_register_form.controls.pan_number.errors !== null">
            {{ agent_register_form.controls.pan_number.errors['error']}}
          </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Ration Card Number
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['ration_card_number']" (click)="allowPermission('ration_card_number')"
                class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['ration_card_number']"
                (click)="updateAgentField('ration_card_number', agent_register_form.value.ration_card_number, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['ration_card_number']) && !agent_register_mode? 'disabled' : null"
            formControlName='ration_card_number'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Aadhar Number <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['aadhar_number']" (click)="allowPermission('aadhar_number')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['aadhar_number']"
                (click)="updateAgentField('aadhar_number', agent_register_form.value.aadhar_number, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['aadhar_number']) && !agent_register_mode? 'disabled' : null"
            formControlName='aadhar_number'>
          <div style="font-style: italic; font-size: small; color:red"
            *ngIf="agent_register_form.controls.aadhar_number.errors !== null">
            {{ agent_register_form.controls.aadhar_number.errors['error']}}
          </div>
        </div>
      </div>
      <div class="col">

        <div class="form-group">
          <label for="exampleFormControlFile1">Aadhar Document <i class="material-icons"
              style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['aadhar_document']" (click)="allowPermission('aadhar_document')"
                class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['aadhar_document']"
                (click)="updateAgentField('aadhar_document', agent_register_form.value.aadhar_document, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="file" class="form-control-file" id="exampleFormControlFile1"
            [attr.disabled]="access(agent_edit_control['aadhar_document']) && !agent_register_mode? 'disabled' : null"
            (change)="toBase64AadharDocument($event)" accept="image/*" value='aadhar_document'>
        </div>
      </div>
      <div class="col" *ngIf="aadhar_document != null">
        <img [src]="aadhar_document" style="height: 100px;">
      </div>
    </div>

    <div class="mat-card-header" style="font-size: medium;  font-weight: 500;  margin-bottom: 13px;  color: #278ecd;">
      Agent Bank Details
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Account holder name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['account_holder_name']" (click)="allowPermission('account_holder_name')"
                class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['account_holder_name']"
                (click)="updateAgentField('account_holder_name', agent_register_form.value.account_holder_name, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['account_holder_name']) && !agent_register_mode? 'disabled' : null"
            formControlName='account_holder_name'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>account_number <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['account_number']" (click)="allowPermission('account_number')"
                class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['account_number']"
                (click)="updateAgentField('account_number', agent_register_form.value.account_number, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['account_number']) && !agent_register_mode? 'disabled' : null"
            formControlName='account_number'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>bank name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['bank_name']" (click)="allowPermission('bank_name')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['bank_name']"
                (click)="updateAgentField('bank_name', agent_register_form.value.bank_name, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['bank_name']) && !agent_register_mode? 'disabled' : null"
            formControlName='bank_name'>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>branch name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['branch_name']" (click)="allowPermission('branch_name')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['branch_name']"
                (click)="updateAgentField('branch_name', agent_register_form.value.branch_name, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['branch_name']) && !agent_register_mode? 'disabled' : null"
            formControlName='branch_name'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>IFSC Code <i class="material-icons" style="color: red;font-size: 14px;">star</i>
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['ifsc_code']" (click)="allowPermission('ifsc_code')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['ifsc_code']"
                (click)="updateAgentField('ifsc_code', agent_register_form.value.ifsc_code, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['ifsc_code']) && !agent_register_mode? 'disabled' : null"
            formControlName='ifsc_code'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>MICR Code
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['micr_code']" (click)="allowPermission('micr_code')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['micr_code']"
                (click)="updateAgentField('micr_code', agent_register_form.value.micr_code, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['micr_code']) && !agent_register_mode? 'disabled' : null"
            formControlName='micr_code'>
        </div>
      </div>

      <!-- <div class="col">
        <div class="form-group">
          <label>GST Number
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['gst_number']" (click)="allowPermission('gst_number')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['gst_number']"
                (click)="updateAgentField('gst_number', agent_register_form.get('agent_gst_number').value, 'Agent')"
                class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>

          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['agent_gst_number']) && !agent_register_mode? 'disabled' : null"
            formControlName='agent_gst_number'>
        </div>
      </div> -->
      <div class="col">
        <div class="form-group">
          <label>GST Number
            <span *ngIf="!agent_register_mode">
              <span *ngIf="agent_edit_control['gst_number']" (click)="allowPermission('gst_number')" class="edit">
                Edit <span class="material-icons" style="font-size: 10px;">create</span>
              </span>
              <span *ngIf="!agent_edit_control['gst_number']"
                (click)="updateAgentField('gst_number', agent_register_form.value.gst_number, 'Agent')" class="save">
                save <span class="material-icons" style="font-size: 10px;">save</span>
              </span>
            </span>
          </label>
          <input type="text" class="form-control code_box"
            [attr.disabled]="access(agent_edit_control['gst_number']) && !agent_register_mode? 'disabled' : null"
            formControlName='gst_number'>
        </div>
      </div>
    </div>

    <button style="margin-left: 40%;" *ngIf="agent_register_mode" mat-raised-button color="primary"
      [disabled]="!agent_register_form.valid" (click)="registerAgent()">{{action}} Agent
      <mat-icon *ngIf="register_on_process">
        <mat-spinner color="accent" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </form>
</div>
<div class="card" style="padding: 25px;margin-top: -18px;" *ngIf="show_register_form">
  <div class="mat-card-header" style="font-size: medium;  font-weight: 500; color: #278ecd;">
    Business Register
    <span class="material-icons" style="float: right;" (click)="showFullBusinessForm()"
      *ngIf="display_business_form">keyboard_arrow_up</span>
    <span class="material-icons" style="float: right;" (click)="showFullBusinessForm()"
      *ngIf="!display_business_form">keyboard_arrow_down</span>
  </div>
  <div class="div" *ngIf="display_business_form" style="margin-top:10px">
    <mat-tab-group (selectedTabChange)="onTabClick($event)" [(selectedIndex)]="selectedIndex">
      <mat-tab *ngFor="let booth of multiple_booth_list; let index = index" [label]="booth">
        <ng-template mat-tab-label>
          {{booth}}
          <span class="material-icons" *ngIf="booth =='new booth '"
            style="margin-left: 11px;color: #020202;">add_circle_outline</span>
        </ng-template>
        <form [formGroup]="booth_register_form" style="margin-top: 20px;">
          <div class="row" style="margin-top: 10px;">
            <div class="col-2">
              <label>Booth Code <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                <!-- <span *ngIf="!booth_register_mode">
                  <span *ngIf="agent_edit_control['code']" (click)="allowPermission('code')" class="edit">
                    Edit <span class="material-icons" style="font-size: 10px;">create</span>
                  </span>
                  <span *ngIf="!agent_edit_control['code']"
                    (click)="updateBusinessField('code', booth_register_form.value.code, 'Agent')" class="save">
                    save <span class="material-icons" style="font-size: 10px;">save</span>
                  </span>
                </span> -->
              </label>
              <input type="text" class="form-control code_box" style="font-weight: 500;"
                [attr.disabled]="access(agent_edit_control['code']) && !booth_register_mode? 'disabled' : null"
                formControlName='code'>
            </div>
            <div class="col-2">
              <button mat-raised-button (click)="checkCode()" style="color:green;    margin-top: 33px;"
                [attr.disabled]="access(agent_edit_control['code']) && !booth_register_mode? 'disabled' : null">Check</button>
              <div style="color:red;    margin-top: 10px;" *ngIf="showError">
                Already Exists !
              </div>
              <i class="material-icons" style="color: green;margin-top: 33px;margin-left: 25px;"
                *ngIf="code_generated">done_all</i>

            </div>
            <div class="col">
              <label>Booth Name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                <span *ngIf="!booth_register_mode">
                  <span *ngIf="agent_edit_control['name']" (click)="allowPermission('name')" class="edit">
                    Edit <span class="material-icons" style="font-size: 10px;">create</span>
                  </span>
                  <span *ngIf="!agent_edit_control['name']"
                    (click)="updateBusinessField('name', booth_register_form.value.name, 'Agent')" class="save">
                    save <span class="material-icons" style="font-size: 10px;">save</span>
                  </span>
                </span>
              </label>
              <input type="text" class="form-control code_box"
                [attr.disabled]="access(agent_edit_control['name']) && !booth_register_mode? 'disabled' : null"
                formControlName='name'>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Booth Type <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <!-- <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['business_type_id']" (click)="allowPermission('business_type_id')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['business_type_id']"
                      (click)="updateBusinessField('business_type_id', booth_register_form.value.business_type_id, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span> -->
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['business_type_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='business_type_id' (ngModelChange)="onChange($event)">
                  <option *ngFor="let booth_type of booth_types" [value]="booth_type['id']">{{booth_type['name']}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </form>
        <!-- <div *ngIf="display_product_prices">
          <div class="row">
            <div class="col-6" style="font-weight: 500;color: gray;font-size: 15px;">
              Input the Discounted Price
            </div>
          </div>
          <span *ngIf="product_price != null">
            <div class="row" style="margin-top: 10px;">
              <div class="col-2" *ngFor="let product of products">
                {{ product['name'] }} - <span style="color: grey;">{{ product['mrp']}} Rs </span>
                <input type="number" style="border: 1px solid lightgrey; border-radius: 6px;    text-indent: 15px;"
                  [(ngModel)]="product_price[product.id]">
              </div>
            </div>
          </span>
        </div> -->
        <form [formGroup]="booth_register_form" style="padding: 6px">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Zone <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['first_name']" (click)="allowPermission('first_name')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['first_name']"
                      (click)="updateBusinessField('zone_id', booth_register_form.value.zone_id, 'Agent')" class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['zone_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='zone_id'>
                  <option *ngFor="let zone of zones" [value]="zone['id']">{{zone['name']}} </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Constituency <i class="material-icons"
                    style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['constituency_id']" (click)="allowPermission('constituency_id')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['constituency_id']"
                      (click)="updateBusinessField('constituency_id', booth_register_form.value.constituency_id, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['constituency_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='constituency_id'>
                  <option *ngFor="let Constituency of constituencies" [value]="Constituency['id']">
                    {{Constituency['name']}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Ward <i class="material-icons"
                    style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['ward_id']" (click)="allowPermission('ward_id')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['ward_id']"
                      (click)="updateBusinessField('ward_id', booth_register_form.value.ward_id, 'Agent')" class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['ward_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='ward_id'>
                  <option *ngFor="let ward of wards[booth_register_form.value.constituency_id]" [value]="ward['id']">
                    {{ward['name']}} </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">

            <div class="col">
              <div class="form-group">
                <label for="exampleFormControlTextarea1">address <i class="material-icons"
                    style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['address']" (click)="allowPermission('address')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['address']"
                      (click)="updateBusinessField('address', booth_register_form.value.address, 'Agent')" class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <textarea class="form-control" rows="2"
                  [attr.disabled]="access(agent_edit_control['address']) && !booth_register_mode? 'disabled' : null"
                  formControlName='address'
                  style="border-radius: 11px; text-indent: 14px;    margin-top: -6px;"></textarea>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Landmark
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['landmark']" (click)="allowPermission('landmark')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['landmark']"
                      (click)="updateBusinessField('landmark', booth_register_form.value.landmark, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <textarea class="form-control" rows="2"
                  [attr.disabled]="access(agent_edit_control['landmark']) && !booth_register_mode? 'disabled' : null"
                  formControlName='landmark' style="border-radius: 11px;"></textarea>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Location Category <i class="material-icons"
                    style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['location_category_id']"
                      (click)="allowPermission('location_category_id')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['location_category_id']"
                      (click)="updateBusinessField('location_category_id', booth_register_form.value.location_category_id, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['location_category_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='location_category_id'>
                  <option *ngFor="let location_category of location_categories" [value]="location_category['id']">
                    {{location_category['name']}} </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label style="white-space: nowrap;">Panchayat/Corporation Name<i class="material-icons"
                    style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['location_category_value']"
                      (click)="allowPermission('location_category_value')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['location_category_value']"
                      (click)="updateBusinessField('location_category_value', booth_register_form.value.location_category_value, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="text" class="form-control code_box"
                  [attr.disabled]="access(agent_edit_control['location_category_value']) && !booth_register_mode? 'disabled' : null"
                  formControlName='location_category_value'>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Pincode <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['business_pincode']" (click)="allowPermission('business_pincode')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['business_pincode']"
                      (click)="updateBusinessField('business_pincode', booth_register_form.value.pincode, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="number" class="form-control code_box"
                  [attr.disabled]="access(agent_edit_control['business_pincode']) && !booth_register_mode? 'disabled' : null"
                  formControlName='pincode'>
              </div>
              <div style="font-style: italic; font-size: small; color: red"
                *ngIf="booth_register_form.controls.pincode.errors !== null">
                {{ booth_register_form.controls.pincode.errors['error']}}
              </div>
            </div>
          </div>
          <div class="row">
            <div cl ass="col-1" *ngIf="!booth_register_mode">
              <span *ngIf="!booth_register_mode">
                <span *ngIf="agent_edit_control['is_rural']" (click)="allowPermission('is_rural')" class="edit">
                  Edit <span class="material-icons" style="font-size: 10px;">create</span>
                </span>
                <span *ngIf="!agent_edit_control['is_rural']"
                  (click)="updateBusinessField('is_rural', booth_register_form.value.is_rural, 'Agent')" class="save">
                  save <span class="material-icons" style="font-size: 10px;">save</span>
                </span>
              </span>
            </div>
            <div class="col">
              <div class="form-check">
                <label class="form-check-label" for="exampleRadios1" style="margin-left: -19px;">
                  Select the Area Type <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                </label>
                <mat-radio-group
                  [attr.disabled]="access(agent_edit_control['is_rural']) && !booth_register_mode? 'disabled' : null"
                  formControlName='is_rural' aria-label="Select an option">
                  <mat-radio-button [value]=true>Rural</mat-radio-button>
                  <mat-radio-button [value]=false style="margin-left: 10px;">Urban</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
          <div class="mat-card-header"
            style="font-size: medium;  font-weight: 500;  margin-bottom: 13px;  color: #278ecd;">
            Nominee
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Nominee first name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['nominee_first_name']"
                      (click)="allowPermission('nominee_first_name')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['nominee_first_name']"
                      (click)="updateBusinessField('nominee_first_name', booth_register_form.value.nominee_first_name, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="text" class="form-control code_box"
                  [attr.disabled]="access(agent_edit_control['nominee_first_name']) && !booth_register_mode? 'disabled' : null"
                  formControlName='nominee_first_name'>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Nominee last name <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['nominee_last_name']" (click)="allowPermission('nominee_last_name')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['nominee_last_name']"
                      (click)="updateBusinessField('nominee_last_name', booth_register_form.value.nominee_last_name, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="text" class="form-control code_box"
                  [attr.disabled]="access(agent_edit_control['nominee_last_name']) && !booth_register_mode? 'disabled' : null"
                  formControlName='nominee_last_name'>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Nominee Relation Type <i class="material-icons"
                    style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['nominee_relation_type_id']"
                      (click)="allowPermission('nominee_relation_type_id')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['nominee_relation_type_id']"
                      (click)="updateBusinessField('nominee_relation_type_id', booth_register_form.value.nominee_relation_type_id, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['nominee_relation_type_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='nominee_relation_type_id'>
                  <option *ngFor="let nominee_relation_type of relation_types" [value]="nominee_relation_type['id']">
                    {{nominee_relation_type['name']}} </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Aadhar number
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['nominee_aadhar_number']"
                      (click)="allowPermission('nominee_aadhar_number')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['nominee_aadhar_number']"
                      (click)="updateBusinessField('nominee_aadhar_number', booth_register_form.value.nominee_aadhar_number, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="text" class="form-control code_box"
                  [attr.disabled]="access(agent_edit_control['nominee_aadhar_number']) && !booth_register_mode? 'disabled' : null"
                  formControlName='nominee_aadhar_number'>
                <div style="font-style: italic; font-size: small; color:red"
                  *ngIf="booth_register_form.controls.nominee_aadhar_number.errors !== null">
                  {{ booth_register_form.controls.nominee_aadhar_number.errors['error']}}
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>phone
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['nominee_phone']" (click)="allowPermission('nominee_phone')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['nominee_phone']"
                      (click)="updateBusinessField('nominee_phone', booth_register_form.value.nominee_phone, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="text" class="form-control code_box"
                  [attr.disabled]="access(agent_edit_control['nominee_phone']) && !booth_register_mode? 'disabled' : null"
                  formControlName='nominee_phone'>
                <div style="font-style: italic; font-size: small; color:red"
                  *ngIf="booth_register_form.controls.nominee_phone.errors !== null">
                  {{ booth_register_form.controls.nominee_phone.errors['error']}}
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleFormControlFile1">Nominee Image
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['nominee_image']" (click)="allowPermission('nominee_image')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['nominee_image']"
                      (click)="updateBusinessField('nominee_image', booth_register_form.value.nominee_image, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="file" class="form-control-file" (change)="toBase64NomineeImage($event)" accept="image/*"
                  value='nominee_image'
                  [attr.disabled]="access(agent_edit_control['nominee_image']) && !booth_register_mode? 'disabled' : null">
              </div>
            </div>
            <div class="col" *ngIf="nominee_image != null">
              <img style="height: 100px;" [src]="nominee_image">
            </div>
          </div>
          <div class="mat-card-header"
            style="font-size: medium;  font-weight: 500;  margin-bottom: 13px;  color: #278ecd;">
            Deposit Details
          </div>
          <div class="row">
            <div class="col" style="margin-top: -13px;">
              <mat-form-field>
                <label>Deposit Date <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['deposit_date']" (click)="allowPermission('deposit_date')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['deposit_date']"
                      (click)="updateBusinessField('deposit_date', booth_register_form.value.deposit_date, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input matInput [matDatepicker]="picker"
                  [attr.disabled]="access(agent_edit_control['deposit_date']) && !booth_register_mode? 'disabled' : null"
                  formControlName='deposit_date'
                  style="    border: 1px solid #ced4da; border-radius: 12px; text-indent: 14px;">
                <mat-datepicker-toggle matSuffix [for]="picker"
                  [attr.disabled]="access(agent_edit_control['deposit_date']) && !booth_register_mode? 'disabled' : null">
                </mat-datepicker-toggle>
                <mat-datepicker #picker
                  [attr.disabled]="access(agent_edit_control['deposit_date']) && !booth_register_mode? 'disabled' : null">
                </mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Deposit Amount <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['deposit_amount']" (click)="allowPermission('deposit_amount')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['deposit_amount']"
                      (click)="updateBusinessField('deposit_amount', booth_register_form.value.deposit_amount, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="number" class="form-control" class="code_box"
                  [attr.disabled]="access(agent_edit_control['deposit_amount']) && !booth_register_mode? 'disabled' : null"
                  formControlName='deposit_amount'>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleFormControlFile1">Deposit Image <i class="material-icons"
                    style="color: red;font-size: 14px;">star</i>
                  <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['deposit_receipt_image']"
                      (click)="allowPermission('deposit_receipt_image')" class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['deposit_receipt_image']"
                      (click)="updateBusinessField('deposit_receipt_image', booth_register_form.value.deposit_receipt_image, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span>
                </label>
                <input type="file" class="form-control-file" (change)="toBase64AgentImage($event)" accept="image/*"
                  value='deposit_receipt_image'
                  [attr.disabled]="access(agent_edit_control['deposit_receipt_image']) && !booth_register_mode? 'disabled' : null">
              </div>
            </div>
            <div class="col" *ngIf="deposit_receipt_image != null">
              <img style="height: 100px;" [src]="deposit_receipt_image">
            </div>
          </div>
          <div class="mat-card-header"
            style="font-size: medium;  font-weight: 500;  margin-bottom: 13px;  color: #278ecd;">
            Route Assign
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Morning Route <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <!-- <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['morg_route_id']" (click)="allowPermission('morg_route_id')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['morg_route_id']"
                      (click)="updateBusinessField('morg_route_id', booth_register_form.value.morg_route_id, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span> -->
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['morg_route_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='morg_route_id'>
                  <option *ngFor="let route of morning_routes" [value]="route['id']">{{route['name']}} </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Evening Route <i class="material-icons" style="color: red;font-size: 14px;">star</i>
                  <!-- <span *ngIf="!booth_register_mode">
                    <span *ngIf="agent_edit_control['eve_route_id']" (click)="allowPermission('eve_route_id')"
                      class="edit">
                      Edit <span class="material-icons" style="font-size: 10px;">create</span>
                    </span>
                    <span *ngIf="!agent_edit_control['eve_route_id']"
                      (click)="updateBusinessField('eve_route_id', booth_register_form.value.eve_route_id, 'Agent')"
                      class="save">
                      save <span class="material-icons" style="font-size: 10px;">save</span>
                    </span>
                  </span> -->
                </label>
                <select class="form-control dropdown_box"
                  [attr.disabled]="access(agent_edit_control['eve_route_id']) && !booth_register_mode? 'disabled' : null"
                  formControlName='eve_route_id'>
                  <option *ngFor="let route of evening_routes" [value]="route['id']">{{route['name']}} </option>
                </select>
              </div>
            </div>
          </div>
        </form>
        <div class="row" style="margin-top: 16px;    padding-bottom: 50px;" *ngIf="booth_register_mode">
          <div class="col-2">
            <button mat-raised-button color="primary" (click)="registerBooth()" [disabled]="!booth_register_form.valid"
              style="text-transform: capitalize">{{action}} <mat-icon *ngIf="register_on_process">
                <mat-spinner color="accent" diameter="20">
                </mat-spinner>
              </mat-icon></button>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

  </div>
</div>